import { render, staticRenderFns } from "./shuangpu_push.vue?vue&type=template&id=e9b1ff2c&scoped=true&"
import script from "./shuangpu_push.vue?vue&type=script&lang=js&"
export * from "./shuangpu_push.vue?vue&type=script&lang=js&"
import style0 from "./shuangpu_push.vue?vue&type=style&index=0&id=e9b1ff2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b1ff2c",
  null
  
)

export default component.exports